
import Alert from 'vux/src/components/alert/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: 'orders',
components: {
Cell,
Group,
CellBox,
Confirm,
Alert,
XButton,
Tab,
TabItem,
Swiper,
SwiperItem
},
data() {
return {
select: '',
opid: '',

orders_closed: [],
orders_unclosed: [],
list: ['未完成', '已完成'],
index: 0,
loadmoreone: '加载更多',
loadmoretwo: '加载更多',
show: true,
hide: true,
isDisabled: false
}
},
methods: {
showMoreorders() {
var offset
var closed
this.isDisabled = true
if (this.index === 1) {
offset = this.orders_closed.length
closed = true
} else {
offset = this.orders_unclosed.length
closed = false
}
var obj = {
headers: {
token: localStorage.getItem('token'),
opid: this.opid
}
}
var app = this
var date = new Date()
var myDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
this.$http.get('/api/v1/payments/' + app.opid + '/orders?type=orders&before=' + myDate + '&offset=' + offset + '&count=10&closed=' + closed, obj)
.then(function (response) {
app.isDisabled = false
if (app.index === 1) {
app.loadmoretwo = '加载中'
if (response.data.length > 0) {
app.loadmoretwo = '加载更多'
} else {
app.hide = false
}
} else {
app.loadmoreone = '加载中'
if (response.data.length > 0) {
app.loadmoreone = '加载更多'
} else {
app.show = false
}
}
var orders = []
orders = response.data
for (var i = 0; i < orders.length; i++) {
switch (orders[i]['type']) {
case 'TX':
orders[i]['type'] = '提现'
break
case 'CZ':
orders[i]['type'] = '充值'
break
case 'JL':
orders[i]['type'] = '奖励'
break
case 'ZF':
orders[i]['type'] = '服务费'
break
case 'FO':
orders[i]['type'] = '维修费用支出';
break
default:
break
}
if (app.index === 0) {
switch (orders[i]['state']) {
case 'SUCCESS':
orders[i]['state'] = '交易成功'
break
case 'FAIL':
orders[i]['state'] = '交易失败'
break
case 'REJECT':
orders[i]['state'] = '交易驳回'
break
case 'USERCANCEL':
orders[i]['state'] = '交易取消'
break
case 'BALSUCCESS':
orders[i]['state'] = '交易成功'
break
case 'BALFAIL':
orders[i]['state'] = '交易失败'
break
default:
break
}
}
if (app.index === 1) {
app.orders_closed.push(orders[i])
} else {
app.orders_unclosed.push(orders[i])
}
}
})
.catch(function (error) {
app.isDisabled = false
if (error.response) {
console.log(error.response.data)
if (error.response.data.error_message) {
app.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).faultstring
})
}
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}
},
created() {
this.opid = localStorage.getItem('userid')
var obj = {
headers: {
token: localStorage.getItem('token'),
opid: this.opid
}
}
var app = this
var date = new Date()
var myDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
this.$http.get('/api/v1/payments/' + app.opid + '/orders?type=orders&before=' + myDate + '&offset=0&count=10&closed=true', obj)
.then(function (response) {
app.orders_closed = response.data
for (var i = 0; i < app.orders_closed.length; i++) {
switch (app.orders_closed[i]['type']) {
case 'TX':
app.orders_closed[i]['type'] = '提现'
break
case 'CZ':
app.orders_closed[i]['type'] = '充值'
break
case 'JL':
app.orders_closed[i]['type'] = '奖励'
break
case 'ZF':
app.orders_closed[i]['type'] = '服务费'
break
case 'FO':
app.orders_closed[i].type = '维修费用支出';
break
default:
break
}
switch (app.orders_closed[i]['state']) {
case 'SUCCESS':
app.orders_closed[i]['state'] = '交易成功'
break
case 'FAIL':
app.orders_closed[i]['state'] = '交易失败'
break
case 'REJECT':
app.orders_closed[i]['state'] = '交易驳回'
break
case 'USERCANCEL':
app.orders_closed[i]['state'] = '交易取消'
break
case 'BALSUCCESS':
app.orders_closed[i]['state'] = '交易成功'
break
case 'BALFAIL':
app.orders_closed[i]['state'] = '交易失败'
break
default:
break
}
}
})
.catch(function (error) {
if (error.response) {
console.log(error.response.data)
if (error.response.data.error_message) {
app.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).faultstring
})
}
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
this.$http.get('/api/v1/payments/' + app.opid + '/orders?type=orders&before=' + myDate + '&offset=0&count=20&closed=false', obj)
.then(function (response) {
console.log(response.data)
app.orders_unclosed = response.data
for (var i = 0; i < app.orders_unclosed.length; i++) {
switch (app.orders_unclosed[i]['type']) {
case 'TX':
app.orders_unclosed[i]['type'] = '提现'
break
case 'CZ':
app.orders_unclosed[i]['type'] = '充值'
break
case 'JL':
app.orders_unclosed[i]['type'] = '奖励'
break
case 'ZF':
app.orders_unclosed[i]['type'] = '服务费'
break
case 'FO':
app.orders_unclosed[i].type = '维修费用支出';
break
default:
break
}
}
})
.catch(function (error) {
if (error.response) {
console.log(error.response.data)
if (error.response.data.error_message) {
app.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).faultstring
})
}
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/orders.vue